module.exports = __webpack_public_path__ + "img/availability_icon.8c4aa8ab.svg";